import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike, BigNumberish, ZeroAddress } from "ethers";
import { RewardFeeder } from "@airdao/bond-periphery/core/contracts/types";

export type RewardParams = {
  rewardAPY: BigNumberish;
  tierMultiplier: BigNumberish;
}

export async function SetRewardParamsForTier(
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardFeeder,
  token: AddressLike,
  tierLevel: BigNumberish,
  params: RewardParams
) {
  const feeder = contracts.getContractByName(contractName) as unknown as RewardFeeder;
  return await feeder.setTierRewards(token, tierLevel, params);
}

export async function RemoveTierParams(
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardFeeder,
  token: AddressLike,
  tierLevel: BigNumberish
) {
  const feeder = contracts.getContractByName(contractName) as unknown as RewardFeeder;
  return await feeder.removeTierRewards(token, tierLevel);
}

export async function ChangeOwner(
  contracts: Contracts,
  contractName: ContractNames = ContractNames.RewardFeeder,
  newOwner: AddressLike
) {
  const feeder = contracts.getContractByName(contractName) as unknown as RewardFeeder;
  return await feeder.transferOwnership(newOwner);
}

export const AdminMethods = {
  SetRewardParamsForTier,
  RemoveTierParams,
  ChangeOwner
};

export default AdminMethods;